<script>
import apiEndpoints from "@/services/apiEndpoints";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import datetime from "@/mixins/datetime";

export default {
  mixins: [tableSearch, datetime],
  components: {
    CommonTableComponent
  },
  data() {
    return {
      isLoading: false,
      dataSelected: [],
      filters: {
        searchValue: "",
        column: "customers.customer_cd",
        dir: "ASC",
      },
      data: [],
      headers: [
        {
          text: '作業予定年月日',
          name: 'scheduled_work_date'
        }, {
          text: '開始時間',
          name: 'start_time'
        }, {
          text: '終了年月日',
          name: 'work_end_date'
        }, {
          text: '終了時間',
          name: 'ending_time'
        }, {
          text: '車両',
          name: 'vehicle'
        }, {
          text: '従業員',
          name: 'employee'
        }, {
          text: 'ステータス',
          name: 'status'
        }, {
          text: '委託先状況',
          name: 'contractor_status'
        }, {
          text: 'メール',
          name: 'email'
        }, {
          text: '変更依頼コメント',
          name: 'change_request_comment'
        },
        {
          text: '履歴用コメント',
          name: 'history_comment'
        },
        {
          text: '更新者',
          name: 'changer'
        },
        {
          text: '更新日',
          name: 'update_date'
        },
      ],
      scheduleId: null,
    }
  },
  methods: {
    async getData() {
      if (!this.scheduleId) return;

      this.isLoading = true;
      const url = apiEndpoints.histories_by_schedule(this.scheduleId);
      const {status, data} = await this.$http.get(url);
      if (status) {
        this.data = data.result;
      }
      this.isLoading = false;
    },
    updateValue: function (value) {
      this.$emit('dataSelected', this.dataSelected)
      this.closeModal();
    },
    openModal(scheduleId) {
      this.scheduleId = scheduleId;
      this.$nextTick(() => {
        this.$bvModal.show("modal-history");
      })
    },
    closeModal() {
      this.$bvModal.hide("modal-history");
    },
  }
}
</script>
<template>
  <div class="d-xl-flex">
    <slot name="openBtn">

    </slot>
    <!-- modal area -->
    <b-modal
      size="xl"
      id="modal-history"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
    >
      <template #modal-header>
        <div class="d-flex justify-content-between align-items-baseline w-100">
          <h5>履歴情報一覧</h5>
          <b-button
            size="lg"
            variant="primary"
            @click="closeModal"
          >
            戻る
          </b-button>
        </div>
      </template>
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div>
            <b-row class="my-4">
              <b-col align-self="center" cols="1">受付番号</b-col>
              <b-col align-self="center" cols="3">
                <b-form-input
                  id="name"
                  :value="scheduleId"
                  :readonly="true"
                ></b-form-input>
              </b-col>
            </b-row>
            <CommonTableComponent :height-class="`table-wrapper-500`">
              <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                <span v-if="item.sortable" @click="clickSort(item.value)">
                  {{ item.text }}
                  <i :class="getSortClass(item.value)"></i>
                </span>
                  <span v-else>
                  {{ item.text }}
                </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in data">
                <td>{{ item.start_datetime | longDate }}</td>
                <td>{{ formatDate(item.start_datetime, 'H:mm') }}</td>
                <td>{{ item.end_datetime | longDate }}</td>
                <td>{{ formatDate(item.end_datetime, 'H:mm') }}</td>
                <td>{{ item.assigned_car_names }}</td>
                <td>{{ item.assigned_user_names }}</td>
                <td>{{ item.zz_reservation_status1.reservation_status_1 }}</td>
                <td>{{ item.zz_reservation_status2.reservation_status_2}}</td>
                <td class="text-center">{{ item.is_email_sent == 1 ? '〇' : '×' }}</td>
                <td>{{ item.comment_of_work_reservation_change_request}}</td>
                <td>{{ item.comment_of_schedule_update}}</td>
                <td>{{ item.user && item.user.user_name }}</td>
                <td>{{ item.update_date | longDate }}</td>
              </tr>
              <tr v-if="!data.length">
                <td colspan="13" class="text-center">
                  データなし。
                </td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
